var validationType = {
  ONCE: 'Once',
  MULTIPLE: 'Multiple',
  OPTIONAL: 'Optional',
  ANY: 'Any'
};
var childType = {
  once: function once() {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }

    return {
      validation: validationType.ONCE,
      names: names
    };
  },
  optional: function optional() {
    for (var _len2 = arguments.length, names = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      names[_key2] = arguments[_key2];
    }

    return {
      validation: validationType.OPTIONAL,
      names: names
    };
  },
  multiple: function multiple() {
    for (var _len3 = arguments.length, names = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      names[_key3] = arguments[_key3];
    }

    return {
      validation: validationType.MULTIPLE,
      names: names
    };
  },
  any: function any() {
    return {
      validation: validationType.ANY
    };
  }
};
export { childType, validationType };